__turbopack_context__.v({
  "bodyContainer": "whQX-q_bodyContainer",
  "bodyPrimary": "whQX-q_bodyPrimary",
  "bodySecondary": "whQX-q_bodySecondary",
  "buttonsRow": "whQX-q_buttonsRow",
  "contentContainer": "whQX-q_contentContainer",
  "footerContainer": "whQX-q_footerContainer",
  "headerRow": "whQX-q_headerRow",
  "modalBody": "whQX-q_modalBody",
  "modalContent": "whQX-q_modalContent",
  "root": "whQX-q_root",
  "title": "whQX-q_title",
  "titleContainer": "whQX-q_titleContainer",
});
